export default __webpack_public_path__ + "static/media/benefit_3.3f00214e.png";